export default __webpack_public_path__ + "static/media/sberbank.41256cd7.png";